module.exports = {
  template: require('./users-form.pug')()
  controller: require('./users-form.ctrl')
  bindings:
    form: '<',
    onSubmit: '&',
    onRefreshConfirmationTokenTimeout: '&'
}
